
export const Topics = () => {
  return (
    <section>
      <h2 className="text-[62px] font-medium mb-8">Signature Topics</h2>
      <ul className="list-disc pl-6 space-y-4 text-[22px] font-inter">
        <li>Building Products That Matter: Strategic Decision-Making in the Age of AI</li>
        <li>Community-Led Growth: Creating Authentic Connection at Scale</li>
        <li>The Human Edge: Developing Critical Soft Skills for the AI Era</li>
        <li>Strategic Leadership: Balancing Innovation with Execution</li>
      </ul>
    </section>
  );
};
